import React, {ReactNode} from 'react';
import styled from 'styled-components';

type Variant = 'default' | 'error';
interface StyledProps {
  variant?: Variant;
}

const variantColorMap: Record<Variant, string> = {
  default: '#fff',
  error: 'red',
};
const StyledInputWrapperWithLabel = styled.div<StyledProps>`
  position: relative;

  /* Style for the input element */
  input {
    width: 100%;
    padding: 10px 0;
    border-bottom: ${(props) => variantColorMap[props.variant || 'default']}
      solid 1px;
    color: white;
    min-height: 48px;
    min-width: 400px;
    box-shadow: none;
    flex: 1;
    @media screen and (max-width: 768px) {
      min-width: auto;
    }
  }

  input:focus:not(:read-only) {
    color: white; /* Set the text color to black when focused */
    border-bottom: ${(props) => variantColorMap[props.variant || 'default']}
      solid 1px;
    padding: 10px 0;
    box-shadow: none;
  }

  /* Style for the placeholder */
  input::placeholder {
    color: #fff; /* Change the color */
    opacity: 0.5;
    font-size: 16px;
  }
  //
  @media screen and (max-width: 768px) {
    input {
      font-size: 14px;
    }

    input::placeholder {
      font-size: 14px;
    }
  }

  label {
    font-size: 12px;
    color: #fff;
    background-color: transparent;
  }
  button {
    color: #fff;
    right: 10px;
    opacity: 0.5;

    &:hover:not(:disabled) {
      color: #fff;
      opacity: 1;
    }
  }
`;

interface InputWrapperProps extends StyledProps {
  children: ReactNode;
}

const InputWrapperWithLabel: React.FC<InputWrapperProps> = ({
  children,
  ...styledVariant
}) => {
  return (
    <StyledInputWrapperWithLabel {...styledVariant}>
      {children}
    </StyledInputWrapperWithLabel>
  );
};

export default InputWrapperWithLabel;
